import { useState } from "react";
import { toast } from "sonner";
import { pu, errMsg } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Flame } from "lucide-react";

/** Capienza del forno: serve per dire sì o no all'orario che chiede il cliente. */
export const CapienzaForno = ({ settings, onSalva }) => {
  const [s, setS] = useState({
    forno_pezzi: settings?.forno_pezzi ?? 0,
    forno_fascia: settings?.forno_fascia ?? 10,
    forno_minimo: settings?.forno_minimo ?? 20,
  });

  const salva = async () => {
    try {
      await pu("/settings", {
        ...settings,
        forno_pezzi: Number(s.forno_pezzi) || 0,
        forno_fascia: Number(s.forno_fascia) || 10,
        forno_minimo: Number(s.forno_minimo) || 20,
      });
      toast.success("Capienza del forno salvata");
      onSalva?.();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <Card className="space-y-3 p-4" data-testid="capienza-forno">
      <div className="flex items-center gap-2">
        <Flame className="h-4 w-4 text-amber-600" />
        <h3 className="text-lg font-semibold">Capienza del forno</h3>
      </div>
      <p className="text-xs text-slate-500">
        Quando il cliente chiede un'ora, l'app guarda quante pizze sono già promesse in quella fascia
        e risponde sì oppure propone le prime libere. Metti zero per togliere il limite.
      </p>
      <div className="grid grid-cols-3 gap-2">
        {[["forno_pezzi", "pizze per fascia"], ["forno_fascia", "minuti per fascia"],
          ["forno_minimo", "attesa minima (min)"]].map(([k, l]) => (
          <label key={k} className="text-xs font-semibold text-slate-600">
            {l}
            <Input
              type="number"
              min="0"
              className="mt-1"
              value={s[k]}
              onChange={(e) => setS({ ...s, [k]: e.target.value })}
              data-testid={`forno-${k}-input`}
            />
          </label>
        ))}
      </div>
      <Button className="h-11 w-full" onClick={salva} data-testid="salva-forno-btn">
        Salva capienza
      </Button>
    </Card>
  );
};
